import classNames from "classnames";
import React, { PureComponent } from "react";
import { Manager, Popper, PopperProps, Reference } from "react-popper";

import { Portal } from "../Portal";

export interface IPositionWrapperProps extends Omit<PopperProps, "children"> {
  popperComponent: React.ReactNode | null;
  targetComponent?: React.ReactNode;
  hidden?: boolean;
  className?: string;
  targetClassName?: string;
  usePortal?: boolean;
}

export class PositionWrapper extends PureComponent<IPositionWrapperProps> {
  static defaultProps = {
    hidden: false,
    placement: "bottom-start",
  };

  render() {
    const { className, hidden, popperComponent, targetClassName, targetComponent, usePortal, ...popperProps } =
      this.props;
    const classes = classNames(className, "el-position-wrapper-component");

    const popper = (
      <Popper {...popperProps}>
        {({ ref, style, placement }) => (
          <div ref={ref} style={style} data-placement={placement} className={classes}>
            {popperComponent}
          </div>
        )}
      </Popper>
    );

    return (
      <Manager>
        <Reference>
          {({ ref }) => (
            <div className={targetClassName} ref={ref}>
              {targetComponent && targetComponent}
            </div>
          )}
        </Reference>
        {!hidden && (usePortal ? <Portal open>{popper}</Portal> : popper)}
      </Manager>
    );
  }
}

export default PositionWrapper;
